const WebsiteDown = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center px-3">
      <h1 className="fw-bold mb-3">Something went wrong</h1>
      
      <p className="text-muted mb-4" style={{ maxWidth: '500px' }}>
        We're having trouble loading this page. This could be due to a network 
        error or the server might be temporarily unavailable.
      </p>
    </div>
  );
};

export default WebsiteDown;